<template>
    <modify-wrapper isLogin>
        <div class="join-intro join-intro mb-40 mb-md-30">
            <h2 class="text-22 text-md-20 mb-10 mb-md-5">전자제조지원단</h2>
            <p class="text-16 text-md-14 color-gray-7e mb-20 mb-md-10">
                * 전자산업계는 용산의 혁신제품제조를 위해 자문, 교육을 지원하는 전문가 POOL을 지원하기로 함<br class="d-none d-md-block"/>(‘19.10 전자60주년 협약, ’21.10 전자혁신제조 상생협력 협약)
            </p>
            <p class="text-16 text-md-14 color-gray-7e mb-20 mb-md-10"><strong>(전문가)</strong> 전자IT제품 개발, 생산, 제조, 마케팅 분야에서 경험이 풍부한 전·현직 전문가 10명</p>
            <p class="text-16 text-md-14 color-gray-7e mb-20 mb-md-10">
                <strong>(역할)</strong> <u>온라인<small>(전자제조지원단사이트, 이메일 등)</small> 문의에 대한 답변 또는 자문</u>, 필요 시 온라인 강의 또는 대면 회의 등
            </p>
            <p class="text-16 text-md-14 color-gray-7e mb-20 mb-md-10">
                * (자문) 전문분야 → 온라인 질의응답 (Daum Agora, Naver 지식iN과 유사)<br />
                ** (멘토링) 멘토선정 → 온라인 질의응답 (필요 시 온/오프라인 회의
            </p>
            <p class="text-16 text-md-14 color-gray-7e"><strong>(활동비)</strong> 자문료, 강의료, 멘토링비 지급</p>
        </div>
        <div class="login-container mt-0">
            <div class="login-rowgroup">
                <div class="login-row">
                    <v-text-field placeholder="아이디" class="input" type="text" v-model="username" @keydown.enter="$refs['pw'].focus()" hide-details dense />
                </div>
                <div class="login-row">
                    <v-text-field placeholder="비밀번호" class="input" type="password" v-model="password" @keydown.enter="login" ref="pw" hide-details dense />
                </div>
                <div class="login-row login-row--links">
                    <label class="check">
                        <input v-model="remember" class="input" type="checkbox" :value="true" />
                        <i class="icon"></i>
                        <span class="text">아이디 저장</span>
                    </label>
                    <span style="width:50px"></span>
                    <ul class="links">
                        <li><a class="link" href="/login/find-id/">아이디 찾기</a></li>
                        <li><a class="link" href="/login/find-password/">비밀번호 찾기</a></li>
                    </ul>
                </div>
                <div class="login-row login-row--submit">
                    <button class="button button--primary" type="button" @click="login"><span>로그인</span></button>
                </div>
                <!-- <div class="login-row login-row--submit">
                        <a class="button button--border" href="/join/type"><span>회원가입</span></a>
                    </div> -->
            </div>
        </div>
    </modify-wrapper>
</template>

<script>
import CryptoAES from "@/plugins/crypto-aes";
import ModifyWrapper from "./modify-wrapper.vue";

export default {
    components: { ModifyWrapper },
    data() {
        return {
            username: "",
            password: "",

            remember: false,
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        init: function() {
            if (this.$cookies.get("username")) this.username = this.$cookies.get("username");
            // if(this.$cookies.get('password')) this.password = CryptoAES.decrypt(this.$cookies.get('password'));
        },
        async login() {
            try {
                await this.$store.dispatch("login", { username: this.username, password: this.password, remember: this.remember });

                if (this.remember) {
                    this.$cookies.set("username", this.username);
                    this.$cookies.set("password", CryptoAES.encrypt(this.password));
                }
            } catch (error) {
                console.error(error);
                if (error.response) alert(error.response.data.message);
                else alert(error.message);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.join-step {
    margin: 30px auto 50px;
}
.join-intro {
    border: 1px solid #ddd;
    padding: 25px;
}
</style>
